import {ButtonUnstyled, styled} from '@mui/material';

export const Button = styled(ButtonUnstyled)(({theme}) => ({
  background: 'none',
  cursor: 'pointer',
  fontFamily: theme.typography.button.fontFamily,
  transition: 'background 0.2s ease-in-out',
  '&:disabled': {
    background: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
    cursor: 'not-allowed',
  },
}));
